import { Spacer } from './ColorPreview';
import { Column, Row, Font, PaletteInput, PrimaryButton } from './DesignSystem';
import { Palette } from './Palette';
import githubIconTintDark from '../../githubIconTintDark.png';

export function DeploymentPalette({}) {
  return (
    <Palette title="Launch" windowID="launch">
      <Column>
        <Row style={{ marginBlockEnd: '8px' }}>
          <div>
            <Font kind="font-caption">Preview on Mobile</Font>
          </div>
          <Spacer />
          <PrimaryButton text="Open Preview" onClick={() => {}} />
        </Row>
        <Row style={{ marginBlockEnd: '8px' }}>
          <div>
            <Font kind="font-caption">Ship to App Store</Font>
          </div>
          <Spacer />
          <PrimaryButton text="Connect Testflight" onClick={() => {}} />
        </Row>
        <Row style={{ marginBlockEnd: '8px' }}>
          <div>
            <Font kind="font-caption">Add Version Control</Font>
          </div>
          <Spacer />
          <button
            style={{
              display: 'flex',
              alignItems: 'center',
              borderRadius: 12,
              backgroundColor: 'rgb(252, 251, 248)',
              marginInline: '8px',
            }}
          >
            <img
              src={githubIconTintDark}
              alt="GitHub"
              style={{
                width: '25px',
                height: '25px',
                marginInlineEnd: '8px',
              }}
            />
            Connect GitHub
          </button>
        </Row>
        <Row style={{ marginBlockEnd: '8px' }}>
          <div>
            <Font kind="font-caption">Connect to Testflight</Font>
          </div>
          <Spacer />
          <PrimaryButton text="Connect Testflight" onClick={() => {}} />
        </Row>
      </Column>
    </Palette>
  );
}
